import { useEffect } from 'react';

import type { UseInventoryEffectsProps } from '@app/pages/Warehouses/Inventory/types';

export const useInventoryEffects = ({
  searchInventoriesHandler,
}: UseInventoryEffectsProps) => {
  useEffect(() => {
    searchInventoriesHandler();
  }, [searchInventoriesHandler]);
};
